import React from "react";
import { SettingsPage } from "@/pages/SettingsPage";

/**
 * SettingsTab - Wraps the SettingsPage for use inside the ProfilePage tabs.
 * Hides the page-level heading since the tab context provides navigation.
 */
export const SettingsTab: React.FC = () => {
  return (
    <div className="[&>div>div:first-child]:hidden">
      <SettingsPage />
    </div>
  );
};
